import * as React from 'react';
import AntForm, {
	ComponentDecorator,
	FormCreateOption,
	FormProps as AntFormProps,
} from 'antd/lib/form/Form';
import Item from './FormItem';

interface FormProps extends AntFormProps {
	formItemMarginBottom?: boolean;
}
export class Form extends React.Component<FormProps> {
	static Item: typeof Item;
	static create: <TOwnProps>(options?: FormCreateOption<TOwnProps>) => ComponentDecorator;

	render() {
		const { ...props } = this.props;
		return <AntForm {...props} />;
	}
}

Form.Item = Item;
Form.create = AntForm.create;

export default Form;
